(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/betslip-match.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/betslip-match.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.BetslipMatch = Backbone.Marionette.View.extend({
    tagName: 'div',
    className: 'betslip-coupon-row clearfix',
    modelEvents: {
      change: 'render'
    },

    template: function(data) {
      return svs.tipset.templates.betslipmatch(data);
    },

    templateContext: function() {
      var weights = this.model.get('weights'),
        isReduceMode = svs.tipset.models.play.get('isReduceMode')
          ? svs.tipset.models.play.get('isReduceMode')
          : false;

      return {
        isReduceMode: isReduceMode,
        weight1:
          weights[0] === 0
            ? '0%'
            : 100 - Math.round(weights[1]) - Math.round(weights[2]) + '%',
        weightX: Math.round(weights[1]) + '%',
        weight2: Math.round(weights[2]) + '%'
      };
    },

    initialize: function() {
      var self = this;
      this.listenTo(svs.tipset.models.play, 'change', function(e) {
        if (typeof e.changed.isReduceMode === 'undefined') {
          return;
        }

        self.render();
      });
    }
  });
})(Backbone, _, svs);

 })(window);